import { createFileRoute, Outlet } from '@tanstack/react-router'

// Layout de /recovery: solo renderiza el hijo (índice o /recovery/verify) vía
// <Outlet/>. Antes este archivo montaba RecoveryFlow directamente y NO tenía
// Outlet, por eso /recovery/verify mostraba el formulario en vez de la
// verificación. Ahora el formulario vive en recovery.index.tsx.
export const Route = createFileRoute('/recovery')({
  component: () => <Outlet />,
})
